import { render, staticRenderFns } from "./SerialsListPartialPopup.vue?vue&type=template&id=2c1a381f"
import script from "./SerialsListPartialPopup.vue?vue&type=script&lang=js"
export * from "./SerialsListPartialPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports